import config from "../config";
import {sendNotificationInfo} from "../api";
import {useSelector} from "react-redux";

export default function useNotification() {
  const user = useSelector((state) => state.user);
  const subscribe = () => {
    if ("serviceWorker" in navigator && user) {
      navigator.serviceWorker.ready.then(async (registration) => {
        // At this point, we can call methods that require an active
        // service worker, like registration.pushManager.subscribe()
        const pushSubscription = await registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: config.push_notification.vapidKeys.publicKey,
        });
        await sendNotificationInfo({ ...pushSubscription.toJSON(), uid: user.uid }).catch((err) =>
          console.log(err)
        );
      });
    } else {
      console.error("Service workers are not supported.");
    }
  };

  return {subscribe};
}